import React, { useState, useEffect, Fragment } from 'react';
import { convertToCurrency } from '@utils/utils.js';

const Price = ({ product, priceType, matchingVariants, variantIdOnLoad }) => {
    console.log('product in Price', product)
	const [price, setPrice] = useState({});
	const [discountPercent, setDiscountPercent] = useState(0);

	const invalidProductTypes = [
		'Gift Cards',
		'Gift Card',
		'Specialty SKU',
		'Embroidery Option',
		'Embroidery',
		'Virtual Classes',
		'Classes + Events',
		'Classes',
	];

	// Variables for tracking product status
	// let is10Off = false;
	// let is20Off = false;
	// let is25Off = false;
	let is30Off = false;
	let is40Off = false;
	let is50Off = false;
	// let is60Off = false;
	// let is70Off = false;
	let isDoorbuster = false;
	let is40OffDresses = false;
	let isHeartsCollection = false;
	let isUppababySale = false;
	let isDisney = false;

	const tags = product?.tags;
	const vendor = product?.vendor || 'Monica + Andy';
	const productType = product?.product_type;
	const isInvalidProductType = invalidProductTypes.includes(productType);
	const variants = product?.variants;

	// Debug logging for Disney detection
	console.log('🔍 Disney Detection Debug:', {
		productName: product?.title,
		tags: tags,
		hasDisneyTag: tags?.includes('disney'),
		vendor: vendor
	});

	let firstVariantWithInventory;

	if (tags?.includes('uppababysale')) {
		isUppababySale = true;
	}

	if (vendor === 'Monica + Andy' && !isInvalidProductType) {
		firstVariantWithInventory = variants?.find(
			(variant) => variant?.inventory_quantity > 0
		);

		if (
			(tags && tags?.includes('fallhalloween2024')) ||
			tags?.includes('halloween')
		) {
			is50Off = true;
		}

		if (tags?.includes('doorbuster2024')) {
			isDoorbuster = true;
		}

		if (tags?.includes('dressesvday40')) {
			is40OffDresses = true;
		}

		if (tags?.includes('vday2024')) {
			isHeartsCollection = true;
		}

		if (tags?.includes('disney')) {
			isDisney = true;
		}

		// Only apply discount logic if NOT Disney
		if (!isDisney) {
			if (tags?.includes('redwhiteblue2025')) {
				is40Off = true;
			}
		}
	} else if (
		matchingVariants &&
		matchingVariants.length > 0 &&
		!isInvalidProductType
	) {
		firstVariantWithInventory = matchingVariants
			? matchingVariants[0]
			: variants[0];
	} else if (variantIdOnLoad) {
		firstVariantWithInventory = variants?.find(
			(variant) => variant?.id?.toString() === variantIdOnLoad?.toString()
		);
	} else if (!isInvalidProductType) {
		firstVariantWithInventory = variants[0];
	}

	useEffect(() => {
		// Debug logging to see which condition is being met
		console.log('🔍 useEffect Debug:', {
			vendor,
			isInvalidProductType,
			isDisney,
			condition1: vendor === 'Monica + Andy' && !isInvalidProductType && !isDisney,
			condition2: isDisney && vendor === 'Monica + Andy' && !isInvalidProductType,
			condition3: isUppababySale
		});

		// Move all price calculations inside useEffect
		if (vendor === 'Monica + Andy' && !isInvalidProductType && !isDisney) {
			// Check if product is on SALE FIRST - show sale price with strikethrough
			if (product?.title && product?.title.includes('SALE')) {
				const compareAtPrice = convertToCurrency(
					product?.compare_at_price_max
				);
				const salePrice = convertToCurrency(product?.price_max);

				setPrice({
					price: salePrice,
					compareAtPrice: compareAtPrice,
					discountPrice: null,
				});

				// Calculate discount percent from original compare at price to sale price
				const compareAtPriceNum = parseFloat(compareAtPrice) || 0;
				const salePriceNum = parseFloat(salePrice) || 0;

				if (compareAtPriceNum > salePriceNum && salePriceNum > 0 && compareAtPriceNum > 0) {
					const calculatedDiscount = Math.round(((compareAtPriceNum - salePriceNum) / compareAtPriceNum) * 100);
					setDiscountPercent(calculatedDiscount);
				} else {
					setDiscountPercent(0);
				}
				return;
			}

			// 30% off products that are not Disney and are not on SALE
			if (is30Off) {
				setPrice({
					price: convertToCurrency(product?.price_max),
					compareAtPrice: convertToCurrency(
						product?.compare_at_price_max
					),
					discountPrice: convertToCurrency(product?.price_max * 0.7),
				});
				setDiscountPercent(30);
				return;
			}

			if (is40Off) {
				setPrice({
					price: convertToCurrency(product?.price_max),
					compareAtPrice: convertToCurrency(
						product?.compare_at_price_max
					),
					discountPrice: convertToCurrency(product?.price_max * 0.6),
				});
				setDiscountPercent(40);
				return;
			}

			// Fallback for other Monica + Andy products
			setPrice({
				price: convertToCurrency(product?.price_max),
				compareAtPrice: convertToCurrency(
					product?.compare_at_price_max
				),
				discountPrice: null,
			});
			setDiscountPercent(0);
		} else if (isDisney && vendor === 'Monica + Andy' && !isInvalidProductType) {
			// console.log('🔍 ENTERING DISNEY CASE');
			// Disney products - show regular price without additional discounts
			const currentPrice = convertToCurrency(product?.price_max);
			const compareAtPrice = convertToCurrency(product?.compare_at_price_max);


			// Calculate discount percentage if product is on sale
			let discountPercent = 0;


			if (compareAtPrice && parseFloat(compareAtPrice) > parseFloat(currentPrice)) {
				const discountAmount = parseFloat(compareAtPrice) - parseFloat(currentPrice);
				discountPercent = Math.round((discountAmount / parseFloat(compareAtPrice)) * 100);

			}

			setPrice({
				price: currentPrice,
				compareAtPrice: compareAtPrice,
				discountPrice: null,
			});
			setDiscountPercent(discountPercent);


		} else if (isUppababySale) {
			setPrice({
				price: convertToCurrency(product?.price_max),
				compareAtPrice: convertToCurrency(
					product?.compare_at_price_max
				),
				discountPrice: null,
			});

			const compareAtPrice = convertToCurrency(
				product?.compare_at_price_max
			);
			const discountedPrice = convertToCurrency(
				firstVariantWithInventory?.price
			);

			const amountOff = compareAtPrice - discountedPrice;
			const discount = Math.round((amountOff / compareAtPrice) * 100);

			setDiscountPercent(discount);
		}
	}, [
		firstVariantWithInventory,
		isInvalidProductType,
		isUppababySale,
		matchingVariants,
		product,
		variantIdOnLoad,
		vendor,
		isDisney,
	]);

	return (
		<div
			className={`price-wrap flex ${
				priceType === 'product' ? 'ml-auto' : ''
			}`}
		>
			{price.price && !isInvalidProductType ? (
				<div className='price-compare-at-price flex'>
					<div
						className={`product-price flex items-center ${
							priceType && priceType === 'product'
								? 'justify-end'
								: ''
						} lg:flex-nowrap lg:min-w-[210px] ${
							priceType === 'collectionTile'
								? 'text-base font-medium text-flint'
								: priceType === 'quickBuy'
								? 'text-2xl'
								: 'text-2xl text-right'
						}`}
					>
						{price.price &&
						price.discountPrice &&
						price.discountPrice !== null &&
						!price.compareAtPrice ? (
							<Fragment>
								<span
									className={`discounted-price ${
										priceType && priceType === 'product'
											? 'text-lg'
											: 'text-sm'
									}`}
								>
									${convertToCurrency(price.discountPrice)}
								</span>
								<span
									className={`ml-1 compare-at-price text-flint/80 line-through discount-compare this-one ${
										priceType && priceType === 'product'
											? 'text-base'
											: 'text-sm'
									}`}
								>
									${convertToCurrency(price.price)}
								</span>
							</Fragment>
						) : null}

						{price.price &&
						price.discountPrice &&
						price.discountPrice !== null &&
						price.compareAtPrice ? (
							<Fragment>
								<span
									className={`discounted-price ${
										priceType && priceType === 'product'
											? 'text-lg'
											: 'text-sm'
									}`}
								>
									${convertToCurrency(price.discountPrice)}
								</span>
								<span
									className={`ml-1 compare-at-price text-red-500 line-through discount-compare ${
										priceType && priceType === 'product'
											? 'text-base'
											: 'text-sm'
									}`}
								>
									${convertToCurrency(price.compareAtPrice)}
								</span>
							</Fragment>
						) : null}

						{!price.discountPrice &&
						price &&
						price.price !== 0 &&
						price.price !== '0' ? (
							<span className='price this-price text-lg'>
								$
								{convertToCurrency(
									price?.price || product?.price_max || price
								)}
							</span>
						) : null}
						{!price.discountPrice &&
						price.compareAtPrice &&
						price.compareAtPrice !== null &&
						price.compareAtPrice !== price.price ? (
							<span className='ml-1 compare-at-price text-red-500 line-through text-sm'>
								${convertToCurrency(price.compareAtPrice)}
							</span>
						) : null}
						{price.price &&
						!price.discountPrice &&
						price.compareAtPrice &&
						price.price !== price.compareAtPrice &&
						price.discountPrice > 0 &&
						price.discountPrice < price.compareAtPrice ? (
							<Fragment>
								<span className='price'>
									${convertToCurrency(price.discountPrice)}
								</span>
								<span className='ml-1 compare-at-price text-flint/80 line-through text-sm'>
									${convertToCurrency(price.compareAtPrice)}
								</span>
							</Fragment>
						) : null}

						{(price.price === '0' || price.price === 0) && (
							<span>Free</span>
						)}

						{discountPercent && discountPercent > 0 ? (
							<span className='inline-flex ml-2 discount-percent text-red-500 font-semibold text-[10px] min-w-[54px]'>
								{discountPercent}% Off
							</span>
						) : null}
					</div>
				</div>
			) : (
				<span className='price invalid-price text-base'>
					{product?.price_min &&
					product?.price_max &&
					product?.price_min !== product.price_max ? (
						<span>
							$
							{product?.price_min
								? convertToCurrency(product.price_min)
								: null}{' '}
							–{' '}
							{product?.price_max
								? convertToCurrency(product.price_max)
								: null}
						</span>
					) : (
						<span>
							$
							{product?.price_max
								? convertToCurrency(product.price_max)
								: null}
						</span>
					)}
				</span>
			)}
		</div>
	);
};

export default Price;
